import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { reportNotFound } from "@/lib/error-reports";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    reportNotFound(pathname);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-4xl font-bold">Page not found</h1>
      <Button asChild>
        <Link to="/">Back to the app</Link>
      </Button>
    </div>
  );
}
